<template>
  <smart-banner
    bg-color="#FFFFFF"
    direction="row"
    :has-kicker="true"
    kicker-color="#717D96"
    kicker-weight="700"
    :kicker-align="align"
    :title-color="validateTitleColor"
    title-size="h1"
    title-weight="800"
    :title-align="align"
    text-color="#43515A"
    text-size="xs"
    text-weight="400"
    :text-align="align"
    :has-button="false"
    :has-image="false"
    :has-fixed-image="hasFixedImage"
    :image-mobile="hasFixedImage ? imageMobile : ''"
    :image-tablet="hasFixedImage ? imageTablet : ''"
    :image-desktop="hasFixedImage ? imageDesktop : ''"
    :alt="hasFixedImage ? alt : ''"
    :center-items="false"
    :reduce-width="false"
    :has-video="false"
  >
    <template #breadcrumb>
      <slot name="septenary-breadcrumb" />
    </template>
    <template #kicker>
      <slot name="septenary-kicker" />
    </template>
    <template #title>
      <slot name="septenary-title" />
    </template>
    <template #text>
      <slot name="septenary-text" />
    </template>
  </smart-banner>
</template>

<script>
import { computed } from 'vue'
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-septenary',
  components: {
    SmartBanner,
  },
  props: {
    direction: {
      type: String,
    },
    align: {
      type: String,
    },
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    alt: {
      type: String,
    },
    hasFixedImage: {
      type: Boolean,
      default: false
    },
    titleColor: {
      type: String,
      default: '#1A202C'
    }
  },
  setup(props) {
    const validateTitleColor = computed(() => {
      return props.titleColor === '#1A202C' ? '#1A202C' : '#000000'
    })

    return {
      validateTitleColor
    }
  },
}
</script>

<style lang="scss" scoped>
.smart-banner {
  @include textAlign();
}
</style>
